// @flow
import { ReduxAsyncAction } from '../support/utils';
import dash_api from '../support/dash_api';
import NotificationActions from './NotificationActions';

/**
 * Gets api keys for a user
 * @return {Object} action
 */
const GetUserApiKeys = new ReduxAsyncAction('GET_USER_API_KEYS');
GetUserApiKeys.registerRequest(() => {
  return dash_api.post(`/v1/auth-service/get-key`).then(res => res.data);
});

export const GET_USER_API_KEYS = GetUserApiKeys.constants;
export const getUserApiKeys = GetUserApiKeys.request;

/**
 * Creates an api key
 * @return {Object} action
 */
const CreateUserApiKey = new ReduxAsyncAction('CREATE_USER_API_KEY');
CreateUserApiKey.registerRequest(() => {
  return dash_api
    .post(`/v1/auth-service/generate-key`)
    .then(({ data }) => {
      NotificationActions.showNotification(
        'Your access token has been successfully created',
        'success'
      );
      return data;
    })
    .catch(err => {
      NotificationActions.showNotification(
        'There was an error creating your key',
        'error'
      );
    });
});

export const CREATE_USER_API_KEY = CreateUserApiKey.constants;
export const createUserApiKey = CreateUserApiKey.request;

/**
 * Reset Key
 * @param resetImmediately
 */
const ResetUserApiKey = new ReduxAsyncAction('RESET_USER_API_KEY');
ResetUserApiKey.registerRequest(resetImmediately => {
  return dash_api
    .post(`/v1/auth-service/reset-key`, { reset_immediately: resetImmediately })
    .then(({ data }) => {
      NotificationActions.showNotification(
        'Your access token has been successfully reset',
        'success'
      );
      return data;
    })
    .catch(err => {
      NotificationActions.showNotification(
        'There was an error resetting your key',
        'error'
      );
    });
});

export const RESET_USER_API_KEY = ResetUserApiKey.constants;
export const resetUserApiKey = ResetUserApiKey.request;
